import { SubmitButton as SubmitButtonType } from '@/schemas/sceneDataSchema';
import { ComponentButton } from './ComponentButton';
import useAnalytics, { eventName } from '@/hooks/use-analytics';

export const SubmitButton = ({ component }: { component: SubmitButtonType }) => {
  const { trackClick } = useAnalytics();

  return (
    <ComponentButton
      form={component.form_id}
      component={component}
      type='submit'
      onClick={() => trackClick(eventName(component.id), { button_type: component.type })}
    />
  );
};
